const productPaths = {
  PRODUCT: "",
  SEARCH_PRODUCT_ONLINE_ORDER: "/search",
  PRODUCT_ID: (id) => id,
  PLACE_ORDER_ONLINE_ORDER: "/place-order",
  VALIDATE_ORDER_ONLINE_ORDER: "/validate"
};

export default productPaths;
